import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { logoutUser } from '@App/actions/logIn'
import * as cookies from 'js-cookie'

import {
  LOGOUT_USER,
  COOKIES_AUTHORIZATION_TOKEN,
  COOKIES_BLIINK_USERS,
  LOCALSTORAGE_PERSIST,
  IS_ACTIVE,
  EDIT_USER,
  UPDATE_PROFILE_ROUTE,
} from '@App/constantes'

import './style.scss'

const UserInformation: any = ({
  user,
  logout,
  history,
}: any) => {
  const container: any = React.useRef(null)
  const dropDown: any = React.useRef(null)

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  const handleClickOutside = (e: any) => {
    if (!container.current.contains(e.target)) {
      dropDown.current.classList.remove(IS_ACTIVE)
    }
  }

  const handleClickInside = () => {
    dropDown.current.classList.toggle(IS_ACTIVE)
  }

  return (
    <div className="userInformation">
      <div ref={container}>
        <div
          role="button"
          tabIndex={-10}
          className="wrapperLogo__caret"
          onKeyDown={() => {
          }}
          onClick={handleClickInside}
        >
          <div
            className="dropDownMenu"
            ref={dropDown}
          >
            <div className="profile">
              <div className="profile__media">
                {user && user.image ?
                  <img className="profile__image" src={`${user.image}`} alt="profile" onError={(i: any) => {
                    i.target.style.display = 'none'
                  }} /> : null}
              </div>
              <div className="profile__account">
                <p className="profile__title">
                  {`${user.firstName} ${user.lastName}`}
                </p>
                <p className="profile__subtitle">
                  {user.email}
                </p>
              </div>
            </div>
            <div
              role="link"
              tabIndex={-10}
              key="OPEN__PROFILE__BUTTON"
              className="link link--left"
              onKeyDown={() => {
              }}
              onClick={() => history.push(UPDATE_PROFILE_ROUTE)}
            >
              {EDIT_USER}
            </div>
            <div
              role="link"
              tabIndex={-9}
              key="SIGNOUT__BUTTON"
              className="link link--left"
              onKeyDown={() => {
              }}
              onClick={() => {
                logoutUser()
              }}
            >
              {LOGOUT_USER}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => {
  const {
    user: {
      user,
    },
  } = state

  return {
    user,
  }
}

const mapDispatchToProps = () => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserInformation))
